import { Map } from 'immutable';

import { FIND, REPLACE } from '../../../../constants/bulkEdit';
import { VALUE } from '../../../../constants/product';
import ATTRIBUTE from '../../../../constants/attributes';

export function seo({ attribute, findAndReplaceOperation, preview }) {
  const type = preview.getIn([ATTRIBUTE.SEO, attribute, 'operation']);
  return {
    payload: Map({
      type,
      value: type === findAndReplaceOperation
        ? Map({
          find: preview.getIn([ATTRIBUTE.SEO, attribute, FIND]),
          replace: preview.getIn([ATTRIBUTE.SEO, attribute, REPLACE]),
        })
        : preview.getIn([ATTRIBUTE.SEO, attribute, VALUE], ''),
    }),
  };
}
